export const DEFAULT_QUANTITY = 1
